<template>
  <div id='app'>
    <!-- 头部 -->
    <header-view v-if="visible" :header-style="headerStyle" />
    <!-- 路由 -->
    <router-view />
    <!-- 友情链接 -->
    <footer-view v-if="visible" :header-style="headerStyle" />
    <chat-popup v-if="switchList.zhiliao_status" ref="chat" />

    <!-- 修改默认密码引导 -->
    <guide-change-pwd />
  </div>
</template>

<script>
// 组件
import HeaderView from '@/Header';
import FooterView from '@/Footer';
import ChatPopup from '@/ChatPopup';
import GuideChangePwd from '@/guide-change-pwd'
// 状态
import { mapState } from 'vuex';

export default {
  name: 'App',
  data() {
    return {
      visible: true,
      hiddenList: ['/download', '/pay']
    };
  },
  components: {
    HeaderView,
    FooterView,
    ChatPopup,
    GuideChangePwd
  },
  computed: mapState({
    headerStyle: state => state.app.headerStyle,
    config: state => state.config.config,
    switchList: state => state.config.switchList
  }),
  created() {
    this.setHeader();
    // hiddenList中的页面不显示头部和底部
    if (this.hiddenList.indexOf(this.$route.path) !== -1) {
      this.$set(this, 'visible', false);
    } else {
      this.$set(this, 'visible', true);
    }
  },
  beforeUpdate() {
    this.setHeader();
    // hiddenList中的页面不显示头部和底部
    if (this.hiddenList.indexOf(this.$route.path) !== -1) {
      this.$set(this, 'visible', false);
    } else {
      this.$set(this, 'visible', true);
    }
  },
  methods: {
    /* 设置头部样式 */
    setHeader() {
      const _this = this;
      if (_this.$route.name === 'EnterpriseRegister') {
        // 注册
        _this.$store.dispatch('setHeaderStyle', 2);
      } else {
        // 其他
        _this.$store.dispatch('setHeaderStyle', 1);
      }
    },
    cacheFunction() {
      this.$confirm('确定离开此页面?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '离开成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }
  }
};
</script>

<style lang='less'>
body {
  background-color: #F8F8F8;
}
/* title 为了兼容旧的样式，有的地方还在用 */
.v-title {
  overflow: hidden;
  height: 63px;
  border-bottom: 1px solid #efefef;
}
.v-title-name {
  float: left;
  line-height: 63px;
  font-size: 18px;
  color: #333333;
  padding-left: 29px;
  position: relative;
}
.v-title-name::after {
  content: '';
  position: absolute;
  left: 0;
  top: 20px;
  width: 8px;
  height: 24px;
  background: #4a88f7;
}
.v-title-href {
  float: right;
  line-height: 63px;
}
/* element 初始化样式 */
.el-menu-item * {
  vertical-align: baseline;
}
.el-notification__group {
  position: initial;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: initial;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border: initial;
  color: inherit;
}
.el-menu-item.is-active {
  color: initial;
}
.el-select-dropdown__wrap {
  max-height: 430px;
}
.el-table__body, .el-table__footer, .el-table__header, .el-table__empty-block {
  min-width: 100%;
}
.el-table__empty-text {
  line-height: 200px;
}
/* select tags  tag的关闭按钮显示白色 */
.el-select .el-tag__close.el-icon-close::before {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/App.vue